import gql from 'graphql-tag';
import { DEAL_CALL_ACTIVITY_FRAGMENT } from 'modules/dealActivity/api/fragments/dealCallActivity.fragment';
import { DEAL_EMAIL_ACTIVITY_FRAGMENT } from 'modules/dealActivity/api/fragments/dealEmailActivity.fragment';
import { DEAL_NOTE_ACTIVITY_FRAGMENT } from 'modules/dealActivity/api/fragments/dealNoteActivity.fragment';
import { DEAL_SMS_ACTIVITY_FRAGMENT } from 'modules/dealActivity/api/fragments/dealSmsActivity.fragment';
import { DEAL_EVENT_ACTIVITY_HUB_FRAGMENT } from 'modules/dealActivity/api/fragments/dealEventActivityHub.fragment';

export const GET_CUSTOMER_DEAL_ACTIVITIES = gql`
  query CustomerDealActivities($input: CustomerDealActivitiesInput!) {
    customer {
      customerDealActivities(input: $input) {
        error
        success
        list {
          ...DealCallActivityFields
          ...DealNoteActivityFields
          ...DealEmailActivityFields
          ...DealSmsActivityFields
          ...DealEventActivityHubFields
          __typename
        }
      }
    }
  }
  ${DEAL_CALL_ACTIVITY_FRAGMENT}
  ${DEAL_NOTE_ACTIVITY_FRAGMENT}
  ${DEAL_EMAIL_ACTIVITY_FRAGMENT}
  ${DEAL_SMS_ACTIVITY_FRAGMENT}
  ${DEAL_EVENT_ACTIVITY_HUB_FRAGMENT}
`;
